var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { scrollable: "", persistent: "", width: "450px" },
      model: {
        value: _vm.valueData,
        callback: function ($$v) {
          _vm.valueData = $$v
        },
        expression: "valueData",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_c("span", [_vm._v("알림")])]),
          _vm._v(" "),
          _c("v-card-text", { staticStyle: { "max-height": "200px" } }, [
            _c("div", { staticStyle: { "white-space": "pre-line" } }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.ok()
                    },
                  },
                },
                [_c("span", [_vm._v("확인")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }